import { Store } from 'src/state/store.type';

import { AuthorizationErrorCodes } from './user.type';

export const selectUserNotAuthorizedReason = ({ user }: Store): AuthorizationErrorCodes | undefined => {
	return user.userNotAuthorizedReason;
};
